import { useEffect, useState } from 'react';
import { useActivityContext } from '../context/activity-store';
import { ModalOptions } from '../typings/activity/modal-types';
import useCancelPayment from './use-cancel-payment';
var useActivityRefetch = function (_a) {
    var _b;
    var currentModal = _a.currentModal, currentTransaction = _a.currentTransaction, refetchAccountActivity = _a.refetchAccountActivity, setCurrentModal = _a.setCurrentModal;
    var isPendingPayment = (currentTransaction === null || currentTransaction === void 0 ? void 0 : currentTransaction.status) === 'PENDING' &&
        (currentTransaction === null || currentTransaction === void 0 ? void 0 : currentTransaction.type) === 'PAYMENT';
    var paymentIdObj = (_b = currentTransaction === null || currentTransaction === void 0 ? void 0 : currentTransaction.identifiers) === null || _b === void 0 ? void 0 : _b.find(function (identifier) { return identifier.idType === 'PAYMENT_ID'; });
    var paymentIdValue = paymentIdObj === null || paymentIdObj === void 0 ? void 0 : paymentIdObj.id;
    var emptyNextCursor = useActivityContext().emptyNextCursor;
    var _c = useState(''), paymentId = _c[0], setPaymentId = _c[1];
    var _d = useState(true), isUpdateActivity = _d[0], setIsUpdateActivity = _d[1];
    var _e = useCancelPayment(paymentId), cancelPaymentError = _e.cancelPaymentError, cancelPaymentFetching = _e.cancelPaymentFetching, cancelPaymentSuccess = _e.cancelPaymentSuccess;
    var shouldCancelPaymentRender = isPendingPayment;
    useEffect(function () {
        if (currentModal === ModalOptions.cancelInitiated) {
            emptyNextCursor();
            setPaymentId(paymentIdValue);
        }
        if (!isUpdateActivity) {
            setIsUpdateActivity(true);
        }
    }, [currentModal, isUpdateActivity, paymentIdValue, emptyNextCursor]);
    if (cancelPaymentSuccess && currentModal === ModalOptions.cancelInitiated) {
        setCurrentModal(ModalOptions.cancelComplete);
    }
    if (cancelPaymentError && currentModal === ModalOptions.cancelInitiated) {
        setCurrentModal(ModalOptions.cancelError);
    }
    if (isUpdateActivity &&
        currentModal === ModalOptions.cancelComplete &&
        paymentId) {
        refetchAccountActivity();
        setIsUpdateActivity(false);
        setPaymentId('');
    }
    return {
        cancelPaymentFetching: cancelPaymentFetching,
        cancelPaymentSuccess: cancelPaymentSuccess,
        shouldCancelPaymentRender: shouldCancelPaymentRender
    };
};
export default useActivityRefetch;
//# sourceMappingURL=use-activity-refetch.js.map